import Button from '../Button'
import { styled } from '../../utils/styled'
import Typography from '../Typography'
import Accordion from '../Accordion'
import { DROPDOWN_ITEM_CLASS_NAME } from '../Dropdown/classNames'

export const StyledButtonSelectOpener = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'hasOptionsSelected' && prop !== 'isDropdownOpen'
})<{
  width: string
  hasOptionsSelected: boolean
  isDropdownOpen: boolean
}>(({ width, hasOptionsSelected, isDropdownOpen, theme }) => ({
  width,
  ...(hasOptionsSelected &&
    !isDropdownOpen && {
      backgroundColor: theme.tokens.background.tonal.soft.default,
      '&:hover': {
        backgroundColor: theme.tokens.background.main.pressed,
        boxShadow: `0px 0px 0px 1px inset ${theme.tokens.background.main.pressed}`
      }
    }),
  ...(isDropdownOpen && {
    backgroundColor: theme.tokens.background.main.default,
    boxShadow: `0px 0px 0px 1px ${theme.tokens.background.brand.main.default} inset, 0 0 0 3px ${theme.tokens.background.semantic.info.tonal.soft.default}`
  }),
  '> div': {
    justifyContent: 'space-between',
    display: 'flex',
    width: '100%'
  },
  '.MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    display: 'block',
    textAlign: 'left',
    ...theme.typography.body2
  }
}))

export const StyledTypographyMoreText = styled(Typography)(({ theme }) => ({
  color: theme.tokens.foreground.semantic.info.default
}))

export const StyledAccordionSubOptionsContainer = styled(Accordion)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: theme.borderRadius.xLarge,
  paddingBottom: '8px',
  gap: '8px',
  boxSizing: 'border-box',
  '&::before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    margin: 0,
    backgroundColor: theme.tokens.background.main.pressed,
    borderRadius: theme.borderRadius.xLarge
  },
  '.MuiAccordionSummary-root': {
    padding: 0,
    minHeight: 'unset',
    '.MuiAccordionSummary-content': {
      minHeight: '48px'
    },
    [`.${DROPDOWN_ITEM_CLASS_NAME}`]: {
      margin: 0,
      '&:hover': {
        backgroundColor: theme.tokens.background.tonal.soft.default
      }
    }
  },
  '.MuiAccordionDetails-root': {
    padding: 0,
    [`.${DROPDOWN_ITEM_CLASS_NAME}:hover`]: {
      backgroundColor: theme.tokens.background.tonal.soft.default
    }
  }
}))

/** Valid `li` wrapper for empty-state content inside DropdownList (`ul`). */
export const StyledSubOptionsEmptyContent = styled('li')(() => ({
  listStyle: 'none',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  overflow: 'hidden'
}))
